import Router from 'vue-router'

const recipeRouter = new Router({
  mode: 'history',
  routes: [
    {
      path: '',
      name: 'filters'
    }
  ]
})

export default recipeRouter
